import {Pipe, PipeTransform} from '@angular/core';
import {
    faMoneyBill,
    faPlane, faQuestion, faShoppingBag,
    IconDefinition
} from "@fortawesome/free-solid-svg-icons";
import {ERateType} from "../../../../../service/resources/booking/interfaces/get-bookings.enum";

@Pipe({
    name: 'computeRateIcon'
})
export class ComputeRateIconPipe implements PipeTransform {

    public transportation: IconDefinition = faPlane;
    public fee: IconDefinition = faMoneyBill;
    public service: IconDefinition = faShoppingBag;
    public unknown: IconDefinition = faQuestion;

    public transform(rateTitle: string): IconDefinition {
        if(!rateTitle) {
            return this.unknown;
        }
        switch (rateTitle) {
            case ERateType.Fee:
                return this.fee;
            case ERateType.Service:
                return this.service;
            case ERateType.Transportation:
                return this.transportation;
            default:
                return this.unknown;
        }
    }
}
